import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class BotTemplatePromptManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templates: {},
            templateNames: [],
            selectedTemplate: null,
            templateName: '',
            templateContent: '',
            templateInfo: null,
            loading: false,
            showCreateForm: false,
            showDetailModal: false
        };
        this.baseUrl = global.config.apiDomain + '/rest/bot-template-manager';
        this.getAllTemplateNames = this.getAllTemplateNames.bind(this);
        this.handleSaveTemplate = this.handleSaveTemplate.bind(this);
        this.handleDeleteTemplate = this.handleDeleteTemplate.bind(this);
        this.handleGetTemplate = this.handleGetTemplate.bind(this);
        this.handleGetTemplateInfo = this.handleGetTemplateInfo.bind(this);
        this.handleLoadTemplatesFromFiles = this.handleLoadTemplatesFromFiles.bind(this);
        this.handleClearCache = this.handleClearCache.bind(this);
        this.handleCreateNew = this.handleCreateNew.bind(this);
        this.handleEditTemplate = this.handleEditTemplate.bind(this);
    }

    componentDidMount() {
        this.getAllTemplateNames();
    }

    getAllTemplateNames() {
        this.setState({ loading: true });
        axios.post(this.baseUrl + '/get-all-template-names', {})
            .then(res => {
                if (res.data.status === 'OK') {
                    const templateNames = Object.keys(res.data.templates || {});
                    this.setState({
                        templateNames: templateNames,
                        loading: false
                    });
                } else {
                    toast.error(res.data.message || 'Lỗi khi lấy danh sách templates');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi lấy danh sách templates: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleGetTemplate(templateName) {
        this.setState({ loading: true });
        axios.post(this.baseUrl + '/get-template', { templateName })
            .then(res => {
                if (res.data.status === 'OK') {
                    this.setState({
                        selectedTemplate: templateName,
                        templateName: templateName,
                        templateContent: res.data.content || '',
                        showCreateForm: true,
                        loading: false
                    });
                } else {
                    toast.error(res.data.message || 'Lỗi khi lấy template');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi lấy template: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleGetTemplateInfo(templateName) {
        this.setState({ loading: true });
        axios.post(this.baseUrl + '/get-template-info', { templateName })
            .then(res => {
                if (res.data.status === 'OK') {
                    this.setState({
                        templateInfo: res.data,
                        showDetailModal: true,
                        loading: false
                    });
                } else {
                    toast.error(res.data.message || 'Lỗi khi lấy thông tin template');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi lấy thông tin template: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleSaveTemplate() {
        const { templateName, templateContent } = this.state;
        if (!templateName || !templateName.trim()) {
            toast.error('Vui lòng nhập tên template');
            return;
        }
        if (!templateContent || !templateContent.trim()) {
            toast.error('Vui lòng nhập nội dung template');
            return;
        }

        this.setState({ loading: true });
        axios.post(this.baseUrl + '/save-template', {
            templateName: templateName.trim(),
            content: templateContent
        })
            .then(res => {
                if (res.data.status === 'OK') {
                    toast.success(res.data.message || 'Lưu template thành công');
                    this.setState({
                        showCreateForm: false,
                        selectedTemplate: null,
                        templateName: '',
                        templateContent: '',
                        loading: false
                    });
                    this.getAllTemplateNames();
                } else {
                    toast.error(res.data.message || 'Lỗi khi lưu template');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi lưu template: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleDeleteTemplate(templateName) {
        if (!window.confirm(`Bạn có chắc chắn muốn xóa template "${templateName}"?`)) {
            return;
        }

        this.setState({ loading: true });
        axios.post(this.baseUrl + '/delete-template', { templateName })
            .then(res => {
                if (res.data.status === 'OK') {
                    toast.success(res.data.message || 'Xóa template thành công');
                    this.setState({ loading: false });
                    this.getAllTemplateNames();
                    if (this.state.selectedTemplate === templateName) {
                        this.setState({
                            showCreateForm: false,
                            selectedTemplate: null,
                            templateName: '',
                            templateContent: ''
                        });
                    }
                } else {
                    toast.error(res.data.message || 'Lỗi khi xóa template');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi xóa template: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleLoadTemplatesFromFiles() {
        if (!window.confirm('Bạn có chắc chắn muốn load templates từ files? Hành động này sẽ ghi đè các template hiện có.')) {
            return;
        }

        this.setState({ loading: true });
        axios.post(this.baseUrl + '/load-templates-from-files', {})
            .then(res => {
                if (res.data.status === 'OK') {
                    toast.success(res.data.message || 'Load templates thành công');
                    this.setState({ loading: false });
                    this.getAllTemplateNames();
                } else {
                    toast.error(res.data.message || 'Lỗi khi load templates');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi load templates: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleClearCache() {
        if (!window.confirm('Bạn có chắc chắn muốn xóa cache templates?')) {
            return;
        }

        this.setState({ loading: true });
        axios.post(this.baseUrl + '/clear-template-cache', {})
            .then(res => {
                if (res.data.status === 'OK') {
                    toast.success(res.data.message || 'Xóa cache thành công');
                    this.setState({ loading: false });
                } else {
                    toast.error(res.data.message || 'Lỗi khi xóa cache');
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                toast.error('Lỗi khi xóa cache: ' + err.message);
                this.setState({ loading: false });
            });
    }

    handleCreateNew() {
        this.setState({
            showCreateForm: true,
            selectedTemplate: null,
            templateName: '',
            templateContent: '',
            templateInfo: null
        });
    }

    handleEditTemplate(templateName) {
        this.handleGetTemplate(templateName);
    }

    render() {
        const { 
            templateNames, 
            templateName, 
            templateContent, 
            loading, 
            showCreateForm,
            showDetailModal,
            templateInfo,
            selectedTemplate
        } = this.state;

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lý Template Bot Prompt</h1>
                        <hr />

                        {/* Action buttons */}
                        <div className="mb-3">
                            <button 
                                className="btn btn-primary mr-2"
                                onClick={this.handleCreateNew}
                                disabled={loading}
                            >
                                <i className="fa-solid fa-plus mr-2"></i>
                                Tạo Template Mới
                            </button>
                            <button 
                                className="btn btn-info mr-2"
                                onClick={this.handleLoadTemplatesFromFiles}
                                disabled={loading}
                            >
                                <i className="fa-solid fa-upload mr-2"></i>
                                Load Templates Từ Files
                            </button>
                            <button 
                                className="btn btn-warning mr-2"
                                onClick={this.handleClearCache}
                                disabled={loading}
                            >
                                <i className="fa-solid fa-trash-can mr-2"></i>
                                Xóa Cache
                            </button>
                            <button 
                                className="btn btn-secondary"
                                onClick={this.getAllTemplateNames}
                                disabled={loading}
                            >
                                <i className="fa-solid fa-refresh mr-2"></i>
                                Làm mới
                            </button>
                        </div>

                        {loading && (
                            <div className="text-center mb-3">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}

                        {/* Template list */}
                        <div className="row">
                            <div className="col-md-4">
                                <h3>Danh sách Templates ({templateNames.length})</h3>
                                <div className="list-group" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                    {templateNames.length === 0 ? (
                                        <div className="alert alert-info">Chưa có template nào</div>
                                    ) : (
                                        templateNames.map((name, index) => (
                                            <div key={index} className="list-group-item">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <strong>{name}</strong>
                                                    </div>
                                                    <div>
                                                        <button
                                                            className="btn btn-sm btn-info mr-1"
                                                            onClick={() => this.handleEditTemplate(name)}
                                                            disabled={loading}
                                                            title="Chỉnh sửa"
                                                        >
                                                            <i className="fa-solid fa-edit"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-secondary mr-1"
                                                            onClick={() => this.handleGetTemplateInfo(name)}
                                                            disabled={loading}
                                                            title="Xem chi tiết"
                                                        >
                                                            <i className="fa-solid fa-info-circle"></i>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.handleDeleteTemplate(name)}
                                                            disabled={loading}
                                                            title="Xóa"
                                                        >
                                                            <i className="fa-solid fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            {/* Create/Edit form */}
                            <div className="col-md-8">
                                {showCreateForm ? (
                                    <div className="card">
                                        <div className="card-header">
                                            <h4>{selectedTemplate ? 'Chỉnh sửa Template' : 'Tạo Template Mới'}</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label htmlFor="templateName">Tên Template *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="templateName"
                                                    value={templateName}
                                                    onChange={(e) => this.setState({ templateName: e.target.value })}
                                                    disabled={!!selectedTemplate}
                                                    placeholder="Nhập tên template (ví dụ: male_young)"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="templateContent">Nội dung Template *</label>
                                                <textarea
                                                    className="form-control"
                                                    id="templateContent"
                                                    rows="20"
                                                    value={templateContent}
                                                    onChange={(e) => this.setState({ templateContent: e.target.value })}
                                                    placeholder="Nhập nội dung template (có thể rất dài)..."
                                                    style={{ 
                                                        fontFamily: 'monospace',
                                                        fontSize: '14px',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}
                                                />
                                                <small className="form-text text-muted">
                                                    Số ký tự: {templateContent.length}
                                                </small>
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-success mr-2"
                                                    onClick={this.handleSaveTemplate}
                                                    disabled={loading}
                                                >
                                                    <i className="fa-solid fa-save mr-2"></i>
                                                    Lưu Template
                                                </button>
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => this.setState({ 
                                                        showCreateForm: false,
                                                        selectedTemplate: null,
                                                        templateName: '',
                                                        templateContent: ''
                                                    })}
                                                    disabled={loading}
                                                >
                                                    Hủy
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="alert alert-info">
                                        Chọn một template từ danh sách bên trái để chỉnh sửa hoặc nhấn "Tạo Template Mới"
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Detail Modal */}
                {showDetailModal && templateInfo && (
                    <div 
                        className="modal fade show" 
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Thông tin chi tiết Template: {templateInfo.templateName}</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => this.setState({ showDetailModal: false, templateInfo: null })}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label><strong>Tên Template:</strong></label>
                                        <p>{templateInfo.templateName}</p>
                                    </div>
                                    <div className="form-group">
                                        <label><strong>Ngày tạo:</strong></label>
                                        <p>{templateInfo.createdDate ? new Date(templateInfo.createdDate).toLocaleString('vi-VN') : 'N/A'}</p>
                                    </div>
                                    <div className="form-group">
                                        <label><strong>Cập nhật lần cuối:</strong></label>
                                        <p>{templateInfo.lastUpdated ? new Date(templateInfo.lastUpdated).toLocaleString('vi-VN') : 'N/A'}</p>
                                    </div>
                                    <div className="form-group">
                                        <label><strong>Nội dung:</strong></label>
                                        <textarea
                                            className="form-control"
                                            rows="15"
                                            value={templateInfo.content || ''}
                                            readOnly
                                            style={{ 
                                                fontFamily: 'monospace',
                                                fontSize: '12px',
                                                whiteSpace: 'pre-wrap',
                                                wordWrap: 'break-word'
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => this.setState({ showDetailModal: false, templateInfo: null })}
                                    >
                                        Đóng
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                            this.setState({ showDetailModal: false });
                                            this.handleEditTemplate(templateInfo.templateName);
                                        }}
                                    >
                                        Chỉnh sửa
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

